<template>
    <h2 v-if="headerWithSignature" v-html="headerWithSignature" />
</template>

<script lang="ts">
export default {
    props: {
        text: {
            type: String,
            default: ""
        }
    },
    computed: {
        headerWithSignature() {
            const words = this.text.split(/\s/);
            if (words.length > 1) {
                const head = words[0];
                const tail = words.slice(1).join(" ");
                return `<span class="text-dark">${head}</span> ${tail}`;
            } else {
                return `${this.text}`;
            }
        }
    }
}
</script>
